<app-chart-renderer
  [locale]="locale()"
  [currency]="currency()"
  [metrics]="METRIC_COLUMNS"
  [localStorageKey]="localStorageKey"
  [dataSetConfiguration]="dataSetConfiguration"
  [chartData]="chartData$"
  [selectedMetrics]="selectedMetrics"
  [withRangeSelector]="false"
/>
